// External deps
import axios from 'axios';

// Internal deps
import {
  API_USER_INFO,
} from '../constants/host';
import { apiYClickLogin } from './api';
import { encryptCredentials, encryptWithRSA } from '../utils/encryptionUtils';


export const getUserInfoService = (token) =>
  axios.post(API_USER_INFO, null, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

// It is used from the masters API
export const loginService = (params) => {
  const { userName, password } = params;
  const encryptedData ={
    userName: encryptCredentials(userName),
    password: encryptCredentials(password)
  }
  return apiYClickLogin.post(`/v1/login`, encryptedData)
};

export const loginService2 = (params) => {
  const { userName, password } = params;
  const encryptedData ={
    userName: encryptWithRSA(userName),
    password: encryptWithRSA(password)
  }
  return apiYClickLogin.post(`/v2/login`, encryptedData)
};